export default "__VITE_ASSET__BFIqbj8q__"